import { getTranslation } from "@mivo/i18n";
import { OFFLINE_TRANSLATIONS } from "@/domains/offline/constants";

export class OfflineQueuedError extends Error {
  readonly outboxId: string;

  constructor(outboxId: string) {
    super(getTranslation(OFFLINE_TRANSLATIONS.queuedChangeDescription));
    this.name = "OfflineQueuedError";
    this.outboxId = outboxId;
  }
}

export class OfflineBlockedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "OfflineBlockedError";
  }
}

export function isOfflineQueuedError(err: unknown): err is OfflineQueuedError {
  return err instanceof OfflineQueuedError;
}
